import { get } from "svelte/store"
import { login } from "../store"

export function checkIfStepIsCompleted(task: TaskOilSpillRemoval | TaskTowing, step: number) {
    return task.completedSteps.findIndex((el) => el.stepNr == step) !== -1
}
export function getStepCompletedObject(task: TaskOilSpillRemoval | TaskTowing, step: number) {
    return task.completedSteps.find((el) => el.stepNr == step)
}

export function checkIfStepIsBlockedByOtherUser(stepNr: number, taskEditorsValue: TaskEditors) {
    const currentUserId = get(login).user.id
    return (
        Object.values(taskEditorsValue).find((editor) => editor.stepNr === stepNr) &&
        taskEditorsValue[currentUserId]?.stepNr !== stepNr
    )
}
export function getCurrentBlockingTaskEditor(stepNr: number, taskEditorsValue: TaskEditors) {
    const entry = Object.entries(taskEditorsValue).find((editor) => editor[1].stepNr === stepNr)
    const blockingEditor = { userId: entry[0], ...entry[1] }
    return blockingEditor
}
export function scrollHorizontallyToActiveTab() {
    const activeButton = document.querySelector(".task-steps-tabs .tab.active")
    if (activeButton) {
        activeButton.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
    }
}

export function scrollToBottomOfStepsSectionIntoView() {
    // Scroll bottom of steps section into view with a margin
    const stepsSection = document.querySelector(".task-steps")
    if (stepsSection) {
        const stepsSectionRect = stepsSection.getBoundingClientRect()
        const absoluteElementBottom = stepsSectionRect.bottom + window.pageYOffset
        const viewportHeight = window.innerHeight
        const margin = 200

        if (stepsSectionRect.height + margin <= viewportHeight) {
            // If the element with margin fits into the viewport, scroll to the bottom
            window.scrollTo({
                top: absoluteElementBottom - viewportHeight + margin,
                behavior: "smooth",
            })
        } else {
            // If the element with margin does not fit into the viewport, scroll to make 100px above the element visible
            const absoluteElementTop = stepsSectionRect.top + window.pageYOffset
            window.scrollTo({
                top: absoluteElementTop - margin,
                behavior: "smooth",
            })
        }
    }
}
